import { Component, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { QRCodeModule } from 'angularx-qrcode';

@Component({
  selector: 'app-qr-modal',
  standalone: true,
  imports: [
    FormsModule,
    QRCodeModule
  ],
  templateUrl: './qr-modal.component.html',
  styleUrls: ['./qr-modal.component.css']
})
export class QrModalComponent {

  @Input() qrItem: any; // sub_domain და სხვა მონაცემები
  @Input() qrColor: string = '#56a956'; // QR ფერი

  @ViewChild('qrcodeContainer', { static: false }) qrcodeContainer!: ElementRef;

  constructor(public activeModal: NgbActiveModal) {}

  // ჩამოტვირთვა SVG ფორმატში
  downloadQrCode() {
    const qrCodeElement = this.qrcodeContainer.nativeElement.querySelector('svg'); // ვეძებთ SVG-ს

    if (!qrCodeElement) {
      console.error('QR კოდი ვერ მოიძებნა.');
      return;
    }

    // SVG-ს სერილიზაცია
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(qrCodeElement);

    // Blob და URL
    const blob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    // ჩამოტვირთვის შექმნა
    const a = document.createElement('a');
    a.href = url;
    a.download = 'qr_code.svg';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // URL-ის გაწმენდა
    URL.revokeObjectURL(url);
  }

  closeModal() {
    this.activeModal.close();
  }
}